export default "__VITE_ASSET__756030eb__"